// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bzfy-o-grid{margin:0px !important;padding:0px !important;list-style-type:none !important}.bzfy-o-grid>li{margin:0px !important;padding:0px !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
